import { render, staticRenderFns } from "./PrintMsg.vue?vue&type=template&id=3132b693&scoped=true"
import script from "./PrintMsg.vue?vue&type=script&lang=js"
export * from "./PrintMsg.vue?vue&type=script&lang=js"
import style0 from "./PrintMsg.vue?vue&type=style&index=0&id=3132b693&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132b693",
  null
  
)

export default component.exports